import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
  selector: "app-delete-renderer",
  template: `
    <span
      [ngbTooltip]="isDisabled ? tooltipText : null"
      container="body"
      placement="left">
      <i
        class="fas fa-trash-alt f-14"
        [class.eod-link-danger]="!isDisabled"
        [style.opacity]="isDisabled ? '0.3' : '1'"
        [style.cursor]="isDisabled ? 'not-allowed' : 'pointer'"
        (click)="onClick($event)">
      </i>
    </span>
  `,
  standalone: false,
})
export class DeleteRendererComponent implements ICellRendererAngularComp {
  isDisabled: boolean = false;
  tooltipText: string = "";
  private params: any;

  agInit(params: any): void {
    this.params = params;
    this.isDisabled = params.isDisabled ? params.isDisabled(params.data) : false;
    this.tooltipText = params.tooltipText || "";
  }

  refresh(params: any): boolean {
    this.agInit(params);
    return true;
  }

  onClick(event: Event): void {
    event.stopPropagation();
    if (!this.isDisabled && this.params.onClick) {
      this.params.onClick(this.params.data);
    }
  }
}
